
import { sum, isEmpty, get, flatMap, find, isEqual } from "lodash";

export const LONG_ANSWER_QUESTION_TYPE = 1;
export const SHORT_ANSWER_QUESTION_TYPE = 2;
export const MULTI_SELECT_QUESTION_TYPE = 3;
export const SINGLE_SELECT_QUESTION_TYPE = 4;
export const MEDIA_QUESTION_TYPE = 5;
export const RANGE_QUESTION_TYPE = 6;
export const RANK_QUESTION_TYPE = 7;
export const MULTI_SELECT_RADIO_QUESTION_TYPE = 8;
export const MULTI_SELECT_CHECK_QUESTION_TYPE = 9;
export const PRICE_CAPTURE_QUESTION_TYPE = 11;
export const CONSUMPTION_FREQUENCY_QUESTION_TYPE = 12;
export const NET_PROMOTER_QUESTION_TYPE = 13;
export const IMPORTANT_SATISFACTION_QUESTION_TYPE = 14;
export const TREND_SCORE_QUESTION_TYPE = 15;
export const SECTION = 10;
export const surveyType = "surveys";
export const SURVEY_QUESTION_OPTIONS_LIMIT = 20;
export const SURVEY_QUESTION_LIMIT = 200;
export const SURVEY_OTHER_OPTION_TEXT = "Others";
export const SURVEY_GA_EVENTS_DETAILS_PAGE = "Survey - Full View";

export const SURVEY_TEMPLATE_QUESTION_TYPES = [PRICE_CAPTURE_QUESTION_TYPE];

export const TEMPLATE_SURVEY_TEXTS = {
  toast: {
    duplicateSection: "All questions have been successfully copied, except for the pricing capture questions.",
    deleteSection: "This section contains template questions and cannot be deleted. Please reposition the questions or reposition the section as needed."
  }
}

export const PRICING_SURVEY_LIMITS = {
  startingPrice: {
    max: 5000,
  },
  step: {
    max: 500
  }
}


export const SURVEY_OPTION_TYPES = {
  NORMAL: 0,
  ANY_OTHER: 1,
  ABSENT: 2,
  SHORT_ANSWER: 3,
  LONG_ANSWER: 4,
  MEDIA: 5,
};

export const SURVEY_REPORTS_QUESTION_TEXT = {
  [LONG_ANSWER_QUESTION_TYPE]: "Long Answer",
  [SHORT_ANSWER_QUESTION_TYPE]: "Short Answer",
  [MULTI_SELECT_QUESTION_TYPE]: "Multiple Select",
  [SINGLE_SELECT_QUESTION_TYPE]: "Single Select",
  [CONSUMPTION_FREQUENCY_QUESTION_TYPE]: "Consumption Frequency",
  [NET_PROMOTER_QUESTION_TYPE]: "Taste Evangelist Score",
  [IMPORTANT_SATISFACTION_QUESTION_TYPE]: "Importance Satisfaction Index",
  [TREND_SCORE_QUESTION_TYPE]: "Trend Score",
  [PRICE_CAPTURE_QUESTION_TYPE]: "Price Capture",
  [MEDIA_QUESTION_TYPE]: "Files",
  [RANGE_QUESTION_TYPE]: "Range",
  [RANK_QUESTION_TYPE]: "Rank",
  [MULTI_SELECT_RADIO_QUESTION_TYPE]: "Multiple Grid Single Select",
  [MULTI_SELECT_CHECK_QUESTION_TYPE]: "Checkbox Grid",
  [SECTION]: "Section",
};

export const SURVEY_STATES = {
  DRAFTS: 1,
  PUBLISHED: 2,
  CLOSED: 3,
  EXPIRED: 4,
  PARTICIPATED: 5,
};

export const SURVEY_STATES_ARR = [
  {
    title: "Active",
    state: SURVEY_STATES.PUBLISHED,
  },
  {
    title: "Inactive",
    state: SURVEY_STATES.CLOSED,
  },
  {
    title: "Drafts",
    state: SURVEY_STATES.DRAFTS,
  },
  {
    title: "Participated",
    state: SURVEY_STATES.PARTICIPATED,
  },

];

export const SURVEY_FILE_TYPES = {
  PHOTO: "image",
  DOCUMENT: "document",
  VIDEO_URL: "media_url",
  VIDEO: "video",
};

export const FILTERS_TYPES = {
  INCLUDE: "include_participant",
  EXCLUDE: "exclude_participant"

}

export const getSurveyBlankOption = (optionType) => {
  return {
    id: "",
    title: Number(optionType) === SURVEY_OPTION_TYPES.ANY_OTHER ? SURVEY_OTHER_OPTION_TEXT : "",
    option_type: optionType,
    image_meta: [],
    video_meta: [],
    idKey: Math.random(),
  };
};


export const getSurveyFilesObj = (fileObj, fileType) => {
  switch (fileType) {
    case SURVEY_FILE_TYPES.PHOTO:
      const fileSplit = get(fileObj, "data.original_photo")
        ? fileObj.data.original_photo.split("/")
        : [];
      const fileName = fileSplit[fileSplit.length - 1];
      return {
        meta: fileObj.meta,
        link: fileObj.data.original_photo,
        fileName,
        type: fileType,
      };
    case SURVEY_FILE_TYPES.DOCUMENT:
      return {
        meta: fileObj.meta,
        link: fileObj.data.document_url,
        type: fileType,
        fileName: fileObj.data.orignal_name,
      };
    case SURVEY_FILE_TYPES.VIDEO_URL:
      return {
        meta: fileObj.meta,
        link: fileObj.data.url,
        type: SURVEY_FILE_TYPES.VIDEO_URL,
        fileName: fileObj.data.url,
      };
    default:
      return null;
  }
};

export const getSurveyFormOptionsWithoutIdKey = (options) =>
  options.map((option) => {
    let newObj = { ...option };
    delete newObj.idKey;
    return newObj;
  });

//this func removes idKey & checks for false intensity values
export const getSurveyFormOptionsPayload = (options, isQuestionLevelIntensity = false) =>
  options.map((option) => {
    let newObj = { ...option };
    delete newObj.idKey;
    if (!newObj.is_intensity) {
      delete newObj.intensity
    }
    if (!isQuestionLevelIntensity) {
      delete newObj.is_intensity
    }
    return newObj;
  });

export const downloadSurveyExcelReport = (fileLink, name) => {
  let link = document.createElement("a");
  link.href = fileLink;
  link.setAttribute("download", name);
  link.click();
};

export const SURVEY_FILTER_TYPES = {
  DATE: 'date',
  QUESTION_FILTER: 'question_filter'
}

export const removeFalseFilters = (data) => {
  let questionFilter = [];
  if (!data) return [];
  const isSection = data && !!data.length && data[0].element_type == "section";
  if (isSection) {
    // For isSection case
    questionFilter = data.reduce((acc, section) => {
      const sectionQuestions = section.questions.map(question => {
        const filteredOptions = question.options.filter(option => option.is_selected);
        return { ...question, options: filteredOptions };
      });

      const filteredQuestions = sectionQuestions.filter(question => question.is_selected);
      if (filteredQuestions.length > 0) {
        const sectionData = { ...section, questions: filteredQuestions };
        return [...acc, sectionData];
      }
      return acc;
    }, []);
  } else {
    // For !isSection case
    questionFilter = data
      .map(question => {
        const filteredOptions = question.options.filter(option => option.is_selected);
        return { ...question, options: filteredOptions };
      })
      .filter(question => question.is_selected);
  }

  return [...questionFilter]
}

export const isPreviewURL = (path, search) => {
  return path.includes(search);
};

export const checkIsValidSurveyForUser = (survey, profile) => {
  if (!survey || !profile) return false;
  const { surveys, meta } = survey;

  // user states
  const isAdmin = get(meta, 'isAdmin', false);
  const isCreator = surveys.profile.id === profile.id;

  //survey states
  const isPublished = Number(get(surveys, 'state', '')) === SURVEY_STATES.PUBLISHED;
  const isClosed = Number(get(surveys, 'state', '')) === SURVEY_STATES.CLOSED;
  const isExpired = Number(get(surveys, 'state', '')) === SURVEY_STATES.EXPIRED;
  const isReviewed = get(meta, 'isReviewed', false);
  const isMultiSubmission = get(surveys, 'multi_submission', false);

  if (isClosed || isExpired) return false; // survey invalid no access to fill 

  if (isPublished) { //  published state 
    if (isCreator) return false; // Creator can't fill own survey 
  } else { //non published state 
    if (!isCreator && !isAdmin) return false; // Non creator / Non admin cannot access fill
  }

  if (isReviewed && !isMultiSubmission) return false // single submission cannot access fill

  return true;
}

// helper function to get final submit demography payload 
// ensures in each generation other is set to 0 if other_active is false while submitting
export const getSurveyDemographyPayload = (product) => {
  return Object.entries(product.demography).reduce((acc, [generationKey, generationValue]) => {
    if (generationKey === "other_active") {
      acc[generationKey] = Number(generationValue);
      return acc;
    }
    acc[generationKey] = {
      ...generationValue,
      other: product.demography.other_active ? generationValue.other : 0, // Update `other` based on `other_active`
    };

    return acc;
  }, {});
};


// getting count of gender count
const getCountDemography = (data, type) => {
  const genderCountArray = Object.keys(data[0].demography).map((val) => {
    return val === "other_active" ? 0 : Number(data[0].demography[val][type])
  });
  return sum(genderCountArray);
}

// function for demography count array

export const getDemographyCountArray = (surveyDemographyData) => {
  // getting count of generation count
  const generationCountArray = !isEmpty(surveyDemographyData) && Object.keys(surveyDemographyData[0].demography).map((val) => {
    const value = sum(Object.values(surveyDemographyData[0].demography[val]));
    return { title: val, value: value }
  })

  // combine array of gender count and generation count
  const totalCountArray = !isEmpty(surveyDemographyData) && [{ title: "male", value: getCountDemography(surveyDemographyData, "male") },
  { title: "female", value: getCountDemography(surveyDemographyData, "female") }
    , { title: "other", value: getCountDemography(surveyDemographyData, "other") }, ...generationCountArray
  ]

  return totalCountArray;
};

export const getInitialPayloadForCopy = (isPricingSurvey = false, survey, profile) => {
  if (!survey) return;
  let data = {}
  if (isPricingSurvey) {
    (survey.company && survey.company.is_premium)
      ? data = {
        company_id: survey.company_id,
        profile_id: survey.profile_id,
      }
      : data = (profile.is_premium) ? { profile_id: survey.profile_id } : null;
  } else {
    survey.company
      ? data = {
        company_id: survey.company_id,
        profile_id: survey.profile_id,
      }
      : data = { profile_id: survey.profile_id };
  };
  return data;
};

// func to determine if any option level intensity is modified
export function hasIntensityDifference(options) {
  if (!options || !options.length) return false;
  const intensitySet = new Set();

  for (const option of options) {
    const value = get(option, 'intensity.intensity_values', null);
    const intensityArray = value === null ? [] : Array.isArray(value) ? value : [value];
    intensitySet.add(JSON.stringify(intensityArray)); // Convert to string for deep comparison
  }
  return intensitySet.size > 1;
}
const removeData = (list) => {
  const updatedList = list.map((item => {
    return (
      item.list.map(item => {
        return {
          key: item.key,
          value: item.value
        }
      })
    )
  }))
  return updatedList.flat();
}

export const getIncludeExcludeFilters = (selectedfilters) => {
  const isIncludeFilter = selectedfilters.length !== 0 &&
    selectedfilters.hasOwnProperty(FILTERS_TYPES.INCLUDE) &&
    !!selectedfilters.include_participant.length;
  const isExcludeFilter = selectedfilters.length !== 0 &&
    selectedfilters.hasOwnProperty(FILTERS_TYPES.EXCLUDE) &&
    !!selectedfilters.exclude_participant.length;
  const data = {
    ...(isIncludeFilter && { [FILTERS_TYPES.INCLUDE]: removeData(selectedfilters.include_participant) }),
    ...(isExcludeFilter && { [FILTERS_TYPES.EXCLUDE]: removeData(selectedfilters.exclude_participant) })
  }
  return { ...data };
}

// function for exempt specific key in nested objects of array
export const deepOmit = (obj, keyToOmit) => {
  if (Array.isArray(obj)) {
    return obj.map(item => deepOmit(item, keyToOmit));
  } else if (typeof obj === 'object' && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (key === keyToOmit) return acc;
      acc[key] = deepOmit(value, keyToOmit);
      return acc;
    }, {});
  }
  return obj;
}

//updating options payload for pricing questions 
export const getPricingQuestionUpdatedOptions = (surveyDetails, priceParams, quesId) => {
  let newOptions = [];
  if (Object.values(priceParams).every((_) => !!_)) {
    //doing this as we have to retain id's of options if it exists in original question;
    const formJson = get(surveyDetails, 'form_json', []);
    const isSection = get(surveyDetails, 'is_section', false);
    //section surveys have multi sections & multi questions array 
    const allQuestions = isSection
      ? flatMap(formJson, section => get(section, 'questions', []))
      : formJson;
    const targetQuestion = find(allQuestions, q => Number(q.id) === Number(quesId));
    const existingOptions = targetQuestion ? get(targetQuestion, 'options', []) : false;
    let maxId = Math.max(...(existingOptions.map(_ => Number(_.id))));
    newOptions = Array.from({ length: priceParams.total_value }, (_, i) => {
      const optionTitle = String(Number(priceParams.min_value) + i * priceParams.step);
      const isOptionTitleExist = existingOptions && existingOptions.length && existingOptions.find(o => String(o.title) === String(optionTitle));
      if (!isOptionTitleExist) {
        maxId += 1;
      }

      return {
        ...getSurveyBlankOption(SURVEY_OPTION_TYPES.NORMAL),
        //doing this as we have to retain id's of options if it exists in original question;
        id: isOptionTitleExist ? isOptionTitleExist.id : maxId,
        title: optionTitle,
      }
    });

  }
  return newOptions;

}

export const getQuestionIdAndSectionId = (surveyDetails) => {
  const formJson = get(surveyDetails, 'form_json', []);
  const isSection = get(surveyDetails, 'is_section', false);
  const allQuestions = isSection
    ? flatMap(formJson, section => get(section, 'questions', []))
    : formJson;
  const isiQuestion = allQuestions.filter(q => Number(q.question_type) === IMPORTANT_SATISFACTION_QUESTION_TYPE);
  const maxQuestionID = Math.max(...(allQuestions.map(_ => Number(_.id))));
  const maxSectionId = Math.max(...(formJson.map(_ => Number(_.id))));
  let questionId = isiQuestion.length >= 1 ? (maxQuestionID + 1 + (isiQuestion.length * 2)) : maxQuestionID + 1;
  let sectionId = isSection ? maxSectionId + 1 : 1;
  return {
    questionId,
    sectionId
  }
}

const getAnswerValueFromQuestion = (item) => {
  if (!item.sub_questions.length) return [];
  const answerArray = item.sub_questions.map((_, index) => {
    const isOptionPresent = item.options && item.options.length ? item.options.filter(item => Number(item.question_id) === Number(_.id)) : [];
    return {
      question_id: Number(_.id), //sub question Id from sub_question array
      question_type_id: IMPORTANT_SATISFACTION_QUESTION_TYPE,
      ...(!!isOptionPresent.length && {
        options: [
          {
            ...isOptionPresent[0].value
          }
        ]
      })
    }
  })
  return answerArray;
}

export const getUpdateAnswerJson = (data) => {
  return data.reduce((acc, item) => {
    if (item.question_type_id !== IMPORTANT_SATISFACTION_QUESTION_TYPE) {
      acc.push(item);
    } else {
      acc.push(...getAnswerValueFromQuestion(item));
    }
    return acc;
  }, []);
}


export const getSurveyQuestionTitlePlaceholder = (type) => {
  switch (Number(type)) {
    case CONSUMPTION_FREQUENCY_QUESTION_TYPE:
      return "e.g How frequently do you use or consume this product?";
    case TREND_SCORE_QUESTION_TYPE:
      return "e.g How would you rate the overall likability of XYZ based on your personal experience or perception?";
    case IMPORTANT_SATISFACTION_QUESTION_TYPE:
      return "e.g How important is this product to you?";
    case NET_PROMOTER_QUESTION_TYPE:
      return "e.g On a scale from 0 to 10, how likely are you to recommend this product to your friends and family?";
    default:
      return "Type your question..."
  }
}

export const QUESTION_SEQUENCE = {
  0: "a",
  1: "b"
}

export const SUBQUESTION_TITLE = {
  "importance": "From Importance Section",
  "satisfaction": "From Satisfaction Section"
};

export const checkValidityAsAnOwnerIfEdit = (data, profileId) => {
  if (!data || (data && !data.surveys)) return false;
  const { surveys, meta } = data;
  // checking if creator
  const isCreator = surveys.profile.id === profileId,
    isAdmin = surveys.company ? meta.isAdmin : false;
  return isCreator || isAdmin || false;
};

export const getUpdatedOptions = (options) => {
  if (!options) return false;
  let maxId = Math.max(...(options.map(_ => Number(_.id))));
  let maxOptionId = maxId;
  return options.map((option, index) => {
    let newObj = { ...option };
    if (!maxId) {
      // always index based
      newObj.id = index + 1;
    } else {
      // survey edit mode
      if (option.id) {
        newObj.id = option.id; // keep existing
      } else {
        // assign new incrementing id
        maxOptionId += 1;
        newObj.id = maxOptionId;
      }
    }
    return newObj;
  });
}


export const IMPORTANT_SATISFACTION_TITLES = {
  "importance": "Importance of Product",
  "satisfaction": "Satisfaction of Product"
}

export const IMPORTANT_SATISFACTION_PLACEHOLDER = {
  "importance": "e.g How important is this product to you?",
  "satisfaction": "e.g How satisfied are you with the product?"
}

export const IMPORTANT_SATISFACTION_INDEX_OPTION_TYPES = [
  {
    type: "importance",
    title: "IMPORTANCE SCALE LABELS"
  },
  {
    type: "satisfaction",
    title: "SATISFACTION SCALE LABELS"
  }
]

export const getQuestionsFromJson = (isSection, form) => {
  //section surveys have multi sections & multi questions array 
  const allQuestions = isSection
    ? flatMap(form, section => get(section, 'questions', []))
    : form;

  return allQuestions;
}

// helper functions for survey if and else question drawer

// action options item list for if and else 
export const ACTION_OPTIONS = [
  {
    id: 1,
    title: "jump",
    value: "Jump To",
    label: "Jump To",
    type: "action"
  },
  {
    id: 2,
    title: "end_survey",
    value: "End Survey",
    label: "End Survey",
    type: "action"
  }
]


// function for disable save button  
export function shouldDisableSave(question, singleQuestion, isSectionSurvey) {

  // ✅ shared condition validator
  const checkConditionLogic = (cond) => {
    if (!cond || isEmpty(cond)) return true;

    // Only validate for "jump" action
    if (cond.action !== "jump") return false;

    if (isSectionSurvey) {
      // section survey validations
      if (!cond.section_id) return true; // missing section_id
      if (
        Number(cond.section_id) === Number(question.section.id) && !cond.question_id
      )
        return true; // same section but missing question_id
    } else {
      // non-section survey validations
      if (!cond.question_id) return true; // missing question_id
    }

    return false;
  };

  const singleSelectQuestion = Number(get(question, "question_type", false)) === Number(SINGLE_SELECT_QUESTION_TYPE);

  const questionHasCondition = get(singleQuestion, "outgoing_condition", false);

  // ✅ 1️⃣ Check question-level outgoing_condition
  if (questionHasCondition && checkConditionLogic(singleQuestion.outgoing_condition)) {
    return true;
  }

  if (isEqual(question, singleQuestion) && isEqual(question.options, singleQuestion.options)) {
    return true;
  }

  // ✅ 3️⃣ Check option-level outgoing_condition (only for single-select questions)
  if (singleSelectQuestion && Array.isArray(singleQuestion.options)) {
    for (const option of singleQuestion.options) {
      const cond = option.outgoing_condition;
      if (!cond) continue;

      // detect if options changed — return true to disable save
      // if () {
      //   return true;
      // }

      if (checkConditionLogic(cond)) {
        return true;
      }
    }
  }

  return false; // ✅ Save enabled
}
// get options for questions for if and else 
export const getQuestionsOptions = (questions, addIndex) => {
  if (!questions.length) return [];
  return questions.map((ques, index) => {
    const title = Number(ques.question_type) === IMPORTANT_SATISFACTION_QUESTION_TYPE ? ques.sub_questions[0].title : ques.title;
    const showSubIndex = Number(ques.question_type) === IMPORTANT_SATISFACTION_QUESTION_TYPE ? "(a)" : "";
    return {
      id: ques.id,
      label: title,
      value: title + ques.id,
      title: title,
      type: "question",
      index: `${addIndex + (index + 1)}${showSubIndex}.`
    }
  })
}

// function for get question from section in edit mode
export const getQuestionsFromSection = (isSection, question, isLogicApplied, allSections) => {
  if (!isSection || !get(isLogicApplied, "section_id", false)) return null;
  // logic for pre selected question in case of section
  const isCurrentSection = get(isLogicApplied, "section_id", null) ?
    Number(isLogicApplied.section_id) === Number(question.section.id) : false;
  const section = isCurrentSection ?
    question["section"] :
    allSections.find(_ => Number(_.id) === Number(isLogicApplied.section_id));
  const sectionQuestions = get(section, "questions", false);
  if (!sectionQuestions) {
    return [];
  }

  const targetQuestionIndex = sectionQuestions.findIndex((_) => Number(_.id) === Number(question.id));

  const remainingQuestions = sectionQuestions.slice(targetQuestionIndex + 1);

  const questions = isCurrentSection ?
    getQuestionsOptions(remainingQuestions, targetQuestionIndex + 1) :
    getQuestionsOptions(sectionQuestions, 0);

  return [...questions];
}

export const getUpdatedQuestionsList = (questions, updatedQuestion) => {
  return questions.map((_) => {
    if (Number(_.id) !== Number(updatedQuestion.id)) return { ..._ }
    return {
      ...updatedQuestion
    }
  })
}
const addaddIncomingConditionsWithoutSection = (form) => {
  const incomingMap = {};


  form.forEach(q => {
    if (q.outgoing_condition && q.outgoing_condition.question_id) {
      const targetId = q.outgoing_condition.question_id;
      if (!incomingMap[targetId]) incomingMap[targetId] = [];
      incomingMap[targetId].push({
        question_id: q.id,
        action: q.outgoing_condition.action
      });
    }
    (q.options || []).forEach(opt => {
      if (opt.outgoing_condition && opt.outgoing_condition.question_id) {
        const targetId = opt.outgoing_condition.question_id;
        if (!incomingMap[targetId]) incomingMap[targetId] = [];
        incomingMap[targetId].push({
          question_id: q.id,
          option_id: opt.id,
          action: opt.outgoing_condition.action
        });
      }
    });
  });

  // 2️⃣ Return new questions — always start clean (no stale incoming_condition)
  return form.map(q => {
    const newQ = { ...q };
    delete newQ.incoming_condition; // clear previous incoming_condition

    // 3️⃣ If we have incoming rules for this q, add them
    if (incomingMap[q.id] && incomingMap[q.id].length) {
      newQ.incoming_condition = incomingMap[q.id];
    }

    return newQ;
  });
}
const addaddIncomingConditionsWithSection = (form) => {
  //  Build maps separately for questions and sections
  const incomingQuestionMap = {};
  const incomingSectionMap = {};

  const getIncomingCondition = (data, q, section, type) => {
    const cond = get(data, "outgoing_condition", false);
    if (cond) {
      // For question level jumps

      // logic for getting question from particular section is
      const allQuestionsFromSection = form.find(_ => Number(_.id) === Number(cond.section_id));
      // || (cond.section_id && allQuestionsFromSection.questions.length >= 1)
      // : Number(allQuestionsFromSection.questions[0].id)
      // cond.question_id ?

      if (cond.question_id) {
        // logic for if question id is presnt than incoming logic will add that particular question 
        // else find all questions for that section if question length is grater than or equal to 1 , then logic will add in first question 
        const targetQId = Number(cond.question_id);
        if (!incomingQuestionMap[targetQId]) incomingQuestionMap[targetQId] = [];
        incomingQuestionMap[targetQId].push({
          ...((type === "question" || type === "option") && { question_id: q.id }),
          section_id: section.id,
          ...(type === "option" && { option_id: data.id }),
          action: cond.action
        });
      }
      // For section level jumps
      if ((cond.section_id && !get(cond, "question_id", false))) {
        const targetSectionId = cond.section_id;
        if (!incomingSectionMap[targetSectionId]) incomingSectionMap[targetSectionId] = [];
        incomingSectionMap[targetSectionId].push({
          ...((type === "question" || type === "option") && { question_id: q.id }),
          section_id: section.id,
          ...(type === "option" && { option_id: data.id }),
          action: cond.action
        });
      }
    }


  }

  form.forEach(section => {
    getIncomingCondition(section, null, section, "section");
    (section.questions || []).forEach(q => {
      getIncomingCondition(q, q, section, "question");
      (q.options || []).forEach(opt => {
        getIncomingCondition(opt, q, section, "option");
      });
    });
  });

  //  Return updated form — clear stale incoming_condition first
  return form.map(section => {
    const newSection = { ...section };

    // Clear old section-level incoming_condition
    delete newSection.incoming_condition;
    if (incomingSectionMap[section.id] && incomingSectionMap[section.id].length) {
      newSection.incoming_condition = incomingSectionMap[section.id];
    }

    // Update questions inside section
    newSection.questions = (section.questions || []).map(q => {
      const newQ = { ...q };
      delete newQ.incoming_condition; // clear old

      if (incomingQuestionMap[q.id] && incomingQuestionMap[q.id].length) {
        newQ.incoming_condition = incomingQuestionMap[q.id];
      }

      return newQ;
    });

    return newSection;
  });

}
// add incomming conditions in form json 
export function addIncomingConditions(isSection, form) {
  // Create a lookup of question id to an array of incoming conditions
  if (!isSection) {
    return addaddIncomingConditionsWithoutSection(form);
  } else {
    return addaddIncomingConditionsWithSection(form);
  }
}


// update outgoing conditions in form json after delete question 
export const updatedOutgoingConditionForQuestions = (selectedQuestionForEdit, updatedForm) => {

  // --- helper to update or remove outgoing_condition ---
  const handleOutgoingCondition = (entity, currentPos) => {
    const outgoingCondition = get(entity, "outgoing_condition", false);
    if (!outgoingCondition) return entity;

    const targetQuestionId = get(outgoingCondition, "question_id", false);
    if (!targetQuestionId) return entity;

    const targetPos = updatedForm.findIndex(q => Number(q.id) === Number(targetQuestionId));
    const targetTitle = targetPos !== -1 ? get(updatedForm[targetPos], "title", "") : "";

    const individualDelete =
      selectedQuestionForEdit && Number(targetQuestionId) === Number(selectedQuestionForEdit.id);
    const sectionDelete = targetPos === -1;
    const reorderLogic = currentPos >= targetPos;

    // if condition breaks — remove outgoing_condition
    if (individualDelete || sectionDelete || reorderLogic) {
      const { outgoing_condition, ...rest } = entity;
      return rest;
    }

    // otherwise, update question_title inside outgoing_condition
    if (targetTitle) {
      return {
        ...entity,
        outgoing_condition: {
          ...outgoingCondition,
          question_title: targetTitle,
        },
      };
    }

    return entity;
  };

  // --- main loop ---
  const newForm = updatedForm.map(question => {
    const currentPos = updatedForm.findIndex(q => Number(q.id) === Number(question.id));
    let updatedQuestion = handleOutgoingCondition(question, currentPos);

    if (Number(question.question_type) === SINGLE_SELECT_QUESTION_TYPE) {
      updatedQuestion = {
        ...updatedQuestion,
        options: question.options.map(option =>
          handleOutgoingCondition(option, currentPos)
        ),
      };
    }

    return updatedQuestion;
  });

  return newForm;
  // const newForm = updatedForm.map(question => {
  //   if (Number(question.question_type) !== SINGLE_SELECT_QUESTION_TYPE) return { ...question }
  //   return {
  //     ...question,
  //     options: question.options.map(option => {
  //       const isQuestionIdPresent = get(option, "outgoing_condition.question_id", false);
  //       const currentPos = updatedForm.findIndex(q => Number(q.id) === Number(question.id));
  //       const targetPos = isQuestionIdPresent && updatedForm.findIndex(q => Number(q.id) === Number(isQuestionIdPresent));

  //       // for updating question title
  //       const targetQuestion = targetPos && targetPos !== -1 ? get(updatedForm[targetPos], "title", "") : "";

  //       // condition for deleting individual question for non section or section survey both
  //       const individualDelete = selectedQuestionForEdit && Number(isQuestionIdPresent) === Number(selectedQuestionForEdit.id);

  //       // condition deleting section (effect from question)
  //       const sectionDelete = targetPos === -1;

  //       // condition for reorder one question at a time 
  //       const reorderLogic = currentPos >= targetPos;
  //       if (isQuestionIdPresent && (individualDelete || reorderLogic)) {
  //         // Create a shallow copy without outgoing_condition
  //         const { outgoing_condition, ...rest } = option;
  //         return rest;
  //       }
  //       return {
  //         ...option,
  //         ...(option.outgoing_condition && {
  //           "outgoing_condition": {
  //             ...option.outgoing_condition,
  //             ...(isQuestionIdPresent && targetQuestion && { "question_title": targetQuestion })
  //           }
  //         })
  //       };
  //     })
  //   };
  // });
  // return newForm;
}

export const handleConditionsBreakForSection = (form) => {

  // ✅ shared validator for any entity (section / question / option)
  const isConditionBroken = (cond, context) => {
    if (!cond || cond.action !== "jump") return false;

    const {
      form,
      currentSectionIndex,
      currentQuestionIndex = null,
      section = null,
      question = null,
    } = context;

    const targetSectionId = cond.section_id;
    const targetQuestionId = cond.question_id;

    // --- find target section index ---
    const targetSectionIdx = form.findIndex(
      (s) => Number(s.id) === Number(targetSectionId)
    );

    // --- find target question index ---
    let actualSectionIndexOfQuestionId = -1;
    let targetQuestionIndex = -1;
    if (targetQuestionId) {
      form.forEach((sec, sIdx) => {
        const qIdx = sec.questions.findIndex(
          (q) => Number(q.id) === Number(targetQuestionId)
        );
        if (qIdx !== -1) {
          actualSectionIndexOfQuestionId = sIdx;
          targetQuestionIndex = qIdx;
        }
      });
    }

    // --- current indices ---
    const currentSectionIdx = currentSectionIndex;
    const currentQuestionIdx = currentQuestionIndex;

    // --- rule conditions ---
    const targetSectionBeforeSource = targetSectionIdx < currentSectionIdx;
    const missingTargetQuestion =
      targetSectionIdx === currentSectionIdx && !targetQuestionId;

    const questionMovedToAnotherSection =
      targetQuestionId &&
      actualSectionIndexOfQuestionId !== -1 &&
      actualSectionIndexOfQuestionId !== targetSectionIdx;

    const questionReorderedSameSection =
      actualSectionIndexOfQuestionId === currentSectionIdx &&
      targetQuestionId &&
      currentQuestionIdx !== null &&
      currentQuestionIdx >= targetQuestionIndex;

    const missingSectionJump =
      !targetSectionId && actualSectionIndexOfQuestionId !== currentSectionIdx;

    // --- return true if any logic break ---
    return (
      targetSectionBeforeSource ||
      missingTargetQuestion ||
      (targetSectionId && questionMovedToAnotherSection) ||
      missingSectionJump ||
      (targetSectionId && questionReorderedSameSection)
    );
  };

  // ✅ main loop (sections → questions → options)
  for (let sIdx = 0; sIdx < form.length; sIdx++) {
    const section = form[sIdx];

    // 1️⃣ Check section-level outgoing condition
    if (isConditionBroken(section.outgoing_condition, { form, currentSectionIndex: sIdx, section }))
      return true;

    const questions = Array.isArray(section.questions) ? section.questions : [];

    for (let qIdx = 0; qIdx < questions.length; qIdx++) {
      const question = questions[qIdx];

      // 2️⃣ Check question-level outgoing condition
      if (
        isConditionBroken(question.outgoing_condition, {
          form,
          currentSectionIndex: sIdx,
          currentQuestionIndex: qIdx,
          section,
          question,
        })
      )
        return true;

      const options = Array.isArray(question.options) ? question.options : [];

      // 3️⃣ Check option-level outgoing condition
      for (const opt of options) {
        if (
          isConditionBroken(opt.outgoing_condition, {
            form,
            currentSectionIndex: sIdx,
            currentQuestionIndex: qIdx,
            section,
            question,
          })
        )
          return true;
      }
    }
  }

  return false;
  // for (let sIdx = 0; sIdx < form.length; sIdx++) {
  //   const section = form[sIdx];
  //   const questions = Array.isArray(section.questions) ? section.questions : [];
  //   for (let qIdx = 0; qIdx < questions.length; qIdx++) {
  //     const question = questions[qIdx];
  //     const options = Array.isArray(question.options) ? question.options : [];

  //     for (const opt of options) {
  //       const cond = opt && opt.outgoing_condition;
  //       if (!cond || Object.keys(cond).length === 0) continue;

  //       // validate only 'jump' actions (change or remove if you want to validate other actions)
  //       if (cond.action !== "jump") continue;

  //       const targetSectionId = cond.section_id;
  //       const targetQuestionId = cond.question_id;

  //       // current indices by id
  //       const currentSectionIndex = form.findIndex(
  //         s => Number(s.id) === Number(section.id)
  //       );
  //       const currentQuestionIndex = section.questions.findIndex(
  //         q => Number(q.id) === Number(question.id)
  //       );

  //       // // find target section index in current form
  //       const targetSectionIdx = form.findIndex(s => Number(s.id) === Number(targetSectionId));

  //       // if target section is before source section => broken

  //       let actualSectionIndexOfQuestionId = -1;
  //       let targetQuestionIndex = -1;
  //       if (targetQuestionId) {
  //         form.forEach((sec, sIdx) => {
  //           const qIdx = sec.questions.findIndex(q => Number(q.id) === Number(targetQuestionId));
  //           if (qIdx !== -1) {
  //             actualSectionIndexOfQuestionId = sIdx;
  //             targetQuestionIndex = qIdx;
  //           }
  //         });
  //       }
  //       // question moved across sections
  //       const questionMovedToAnotherSection =
  //         targetQuestionId &&
  //         actualSectionIndexOfQuestionId !== -1 &&
  //         actualSectionIndexOfQuestionId !== targetSectionIdx;

  //       // if question is reordered in same section
  //       const questionReorderedSameSection =
  //         actualSectionIndexOfQuestionId === currentSectionIndex &&
  //         targetQuestionId &&
  //         currentQuestionIndex >= targetQuestionIndex;

  //       if (targetSectionIdx < currentSectionIndex) return true;
  //       if ((targetSectionIdx === currentSectionIndex) && !targetQuestionId) return true;

  //       if (targetSectionId && questionMovedToAnotherSection) return true;
  //       if (!targetSectionId && actualSectionIndexOfQuestionId !== currentSectionIndex) return true;


  //       if (targetSectionId && questionReorderedSameSection) return true;

  //     }
  //   }
  // }

  // return false;
}
// update outgoing conditions in form json after delete question in sections

export const updatedOutgoingConditionForQuestionsSectionWise = (selectedQuestionForEdit, newForm) => {
  // ----------------------------- helper function -----------------------------
  const handleOutgoingCondition = (entity, context) => {
    const cond = get(entity, "outgoing_condition", null);
    if (!cond) return entity;

    const { sectionId, questionId, action } = {
      sectionId: get(cond, "section_id", null),
      questionId: get(cond, "question_id", null),
      action: get(cond, "action", null),
    };

    const {
      currentSectionIndex,
      currentQuestionIndex = null,
      section,
    } = context;

    // --- find where the target section is ---
    const targetSectionIndex = sectionId
      ? newForm.findIndex((s) => Number(s.id) === Number(sectionId))
      : -1;
    const targetSectionTitle =
      targetSectionIndex !== -1 ? newForm[targetSectionIndex].title : "";

    // --- find where target question is ---
    let actualSectionIndexOfQuestionId = -1;
    let targetQuestionIndex = -1;
    let targetQuestionTitle = "";

    if (questionId) {
      newForm.forEach((sec, sIdx) => {
        const qIdx = sec.questions.findIndex(
          (q) => Number(q.id) === Number(questionId)
        );
        if (qIdx !== -1) {
          actualSectionIndexOfQuestionId = sIdx;
          targetQuestionIndex = qIdx;
          targetQuestionTitle =
            (sec.questions.length && sec.questions[qIdx].title) || "";
        }
      });
    }

    // --- various conditions for invalidation ---
    const sectionDeletedOrMerged = sectionId && targetSectionIndex === -1;
    const questionDeleted =
      selectedQuestionForEdit &&
      questionId &&
      Number(questionId) === Number(selectedQuestionForEdit.id);

    const questionMovedToAnotherSection =
      questionId &&
      sectionId &&
      actualSectionIndexOfQuestionId !== -1 &&
      actualSectionIndexOfQuestionId !== targetSectionIndex;

    const sectionReordered =
      targetSectionIndex !== -1 && currentSectionIndex > targetSectionIndex;

    const questionReorderedSameSection =
      actualSectionIndexOfQuestionId === currentSectionIndex &&
      sectionId &&
      questionId &&
      currentQuestionIndex !== null &&
      currentQuestionIndex >= targetQuestionIndex;

    // --- early return if action is end_survey (always valid) ---
    if (action === "end_survey") {
      return {
        ...entity,
        outgoing_condition: { ...cond },
      };
    }

    // --- remove invalid condition ---
    if (
      sectionId &&
      (sectionDeletedOrMerged ||
        questionDeleted ||
        questionReorderedSameSection ||
        sectionReordered ||
        ((targetSectionIndex === currentSectionIndex) && !questionId)) ||
      questionMovedToAnotherSection
    ) {
      const { outgoing_condition, ...rest } = entity;
      return rest;
    }

    // --- handle case: section was added to previously non-section survey ---
    if (!sectionId && action === "jump") {
      if (actualSectionIndexOfQuestionId === currentSectionIndex) {
        return {
          ...entity,
          outgoing_condition: {
            ...cond,
            section_id: newForm[actualSectionIndexOfQuestionId].id,
            section_title: newForm[actualSectionIndexOfQuestionId].title,
            ...(questionId && { question_title: targetQuestionTitle }),
          },
        };
      } else {
        const { outgoing_condition, ...rest } = entity;
        return rest;
      }
    }

    // --- otherwise, update metadata titles ---
    return {
      ...entity,
      outgoing_condition: {
        ...cond,
        ...(sectionId && { section_id: sectionId }),
        ...(sectionId && { section_title: targetSectionTitle }),
        ...(questionId && { question_title: targetQuestionTitle }),
      },
    };
  };

  // ----------------------------- main update logic -----------------------------
  const updatedForm = newForm.map((section, sectionIndex) => {
    let updatedSection = handleOutgoingCondition(section, {
      currentSectionIndex: sectionIndex,
      section,
    });

    updatedSection = {
      ...updatedSection,
      questions: section.questions.map((question, questionIndex) => {
        let updatedQuestion = handleOutgoingCondition(question, {
          currentSectionIndex: sectionIndex,
          currentQuestionIndex: questionIndex,
          section,
        });

        if (Number(question.question_type) === SINGLE_SELECT_QUESTION_TYPE) {
          updatedQuestion = {
            ...updatedQuestion,
            options: question.options.map((option) =>
              handleOutgoingCondition(option, {
                currentSectionIndex: sectionIndex,
                currentQuestionIndex: questionIndex,
                section,
              })
            ),
          };
        }

        return updatedQuestion;
      }),
    };

    return updatedSection;
  });

  return updatedForm;
}

// check logic after question reorder 
export const handleCheckLogicBreak = (isSection, updatedForm) => {

  // ✅ helper to evaluate if an entity’s outgoing_condition breaks logic
  const checkConditionBreak = (entity, currentIndex) => {
    const cond = entity.outgoing_condition;
    if (!cond || cond.action !== "jump") return false;

    const targetQId = cond.question_id;
    if (!targetQId) return false;

    const targetPos = updatedForm.findIndex(q => Number(q.id) === Number(targetQId));
    if (targetPos === -1) return true; // target question deleted

    // logic break if reordered upwards
    return currentIndex >= targetPos;
  };
  if (isSection) {
    return handleConditionsBreakForSection(updatedForm);
  } else {
    for (let qIndex = 0; qIndex < updatedForm.length; qIndex++) {
      const question = updatedForm[qIndex];

      // 1️⃣ check question-level outgoing condition
      if (checkConditionBreak(question, qIndex)) return true;

      const options = question.options || [];
      for (const opt of options) {
        if (checkConditionBreak(opt, qIndex)) return true;
      }
    }
  }
  return false;
}

//  if section itself OR any question in it ,  has incoming or outgoing conditions.
export const sectionHasAnyCondition = (section) => {
  // section-level incoming condition
  if (get(section, "incoming_condition", []).length > 0) {
    return true;
  }
  if (get(section, "outgoing_condition", false)) {
    return true;
  }

  const questions = get(section, "questions", []);

  for (const q of questions) {
    // question-level incoming condition
    if (get(q, "incoming_condition", []).length > 0) {
      return true;
    }

    if (get(q, "outgoing_condition", false)) {
      return true;
    }

    // question options outgoing conditions
    const options = get(q, "options", []);
    if (
      options.some(
        (opt) =>
          opt.outgoing_condition &&
          Object.keys(opt.outgoing_condition).length > 0
      )
    ) {
      return true;
    }
  }

  return false; // nothing found
};

export const getSurveysFirstSectionId = (isSection, survey) => {
  if (!survey || !isSection) return null;
  let id = null;
  const formJson = get(survey, 'form_json', []);
  if (formJson.length) {
    id = formJson[0].id;
  }
  return id;
}



export const CONDITIONAL_LOGIC_TEXT = {
  BREAK_LOGIC_MODAL_TITLE: "Logic Break",
  BREAK_LOGIC_BUTTON_TITLE: "Proceed & Remove Logic",
  QUESTION_REORDER_WITHOUT_MODAL: "This move will break existing logic connections. Do you want to continue?",
  QUESTION_REORDER_WITH_MODAL: (isSection) => `One or more questions you’ve ${isSection ? "moved" : "reorderd"} will break existing logic. Do you want to continue?`,
  SECTION_REORDER_WITH_MODAL: "One or more sections you’ve reordered will break existing logic. Do you want to continue?",
  SECTION_DELETE_TEXT: (hasLogic) => `Are you sure you want to remove this section? This will also remove all the questions in a section ${hasLogic ? " and any logic linked to them" : "."}`,
  QUESTION_DELETE_TEXT: (hasLogic) => `Are you sure you want to remove this question? ${hasLogic ? "This will also remove any logic connected to it." : ""}`,
  OPTION_DELETE_TEXT: "Are you sure you want to remove this option? This will also remove any logic connected to it."
}

